import EventBus from "../EventBus";
import store from "@/store";
import HeartBeat from "../WebsocketHeartBeat";
import Vue from "vue";
import { WS_RECOMMECT_TIMEOUT } from "_lib/constants/socket";
import { getWsId } from "_api/account";
import { extractAPIValues, getRandom, getCookie, setUrlParam, formatDateByTemplet } from "_lib/utils/utils";
import { G } from "../encrypt/index";
import { __DEFAULT_PARAMS__ } from "_api/config"
import m from "js-md5";
const { WS_BASE } = extractAPIValues();
import router from "@/router";

// EventBus处理ws信息，事件名为SOCKET_ + TYPE_MAP
const TYPE_MAP = {
  0: "PING_PONG", // 心跳检测
  2: "ROOM_INFO_CHANGE", // 用户退出、进入频道
  3: "UPDATE_ROOM_INFO", // 更新房间信息
  5: "SEND_MESSAGE", // IM消息
  6: "ROOM_OR_CHANNEL_DELETE", // 房间、频道被删除
  8: "MUTE_USER", // 禁音用户 (已弃用，用32判断)
  9: "OUT_USER", // 踢出用户
  11: "UPDATE_MESSAGE_LIST", // 更新消息列表用户未处理数量
  14: "UPDATE_TASKS", //更新任务列表
  16: "FRIENDS_REQUEST_LIST", // 好友请求列表，包括好友、已发送好友请求的用户、未接受好友请求的用户
  17: "REFUSE_AUDIO", // 被抢麦，退出语音，保留IM状态
  20: "FRIENDS_STATE_UPDATE", // 好友列表增量更新推送，对应type=1的增量版本
  21: "CHANNEL_USER_UPDATE", // 频道列表进出用户增量更新推送，对应type=3的增量版本
  22: "BOX_ACTIVITY_DROP", // 掉宝活动，推送宝箱掉落
  24: "PRIVATE_MESSAGE_READED", // 私聊消息已读更新(客户端中已读)
  26: "UPDATE_ROOM_CUSTOM_EMOJI", // 增量调整表情推送
  27: "ROOM_LIST_DEL_ITEM", // 左侧房间列表删除（删除房间、踢出房间 会推）
  28: "PIN_MESSAGE", //pin消息和取消pin消息推送对应ID等
  29: "OFFICIAL_UNREAD_MESSAGES", // 推送系统消息
  30: "CHANNEL_ANC", //频道公告 发送与取消置顶
  32: "USER_STATE_UPDATE", //频道内用户状态增量更新
  33: "UPDATE_MY_ONLINE_STATE", // 更新我自己的在线状态（和小黑盒同步）
  34: "ROOM_BANNED", // 房间被禁言（不能加语音频道、能加文字频道但是不能发消息）
  35: "USER_LEVEL_UP", // 个人升级推送
  36: "ROOM_LEVEL_UP", // 房间升级推送（只会给房主推）
  41: "TEAM_LIST_UPDATE", // 组队列表增量更新
  42: "POST_AWARD_UPDATE", // 帖子互动消息
  43: "USER_PERMISSION_UPDATE", // 频道用户权限变化 一般用于私密频道权限更改
  51: 'USER_FIRE_FLAG_UPDATED', // 用户火花状态更新
  3001: "ROOM_MEMBER_CHANGE", //房间内成员变化
  3002: "ROOM_THEME_CHANGE", // 房间游戏主题变化
  3003: 'SINGLE_CHANNEL_UPDATE', // 单个频道更新
  5001: "REVOKE_MESSAGE", //撤回消息
  5002: "RECEIVE_AT", //收到at
  5003: "EMOJI_REPLY", //收到表情
  5004: "PARSE_LINK_MESSAGE", // 收到链接解析
  5005: "SET_USER_UNREAD", // 将指定某人的消息置为未读
  5006: "EDIT_MESSAGE", // 编辑消息
  5007: "ADD_ADDITION", // 添加新 addition 字段
  5100: "TEAM_INVITE_UPDATE", //邀约发生变化
  5101: "TEAM_INVITE_REPLY", //邀约成员状态变化
  5102: "ADD_VOTE", // 新增投票信息
  5103: "END_VOTE", // 投票结束
  5104: "GET_VOTE_RESULT", // 获取投票结果
  11001: "TIME_NOTICE", //提醒快到时间
  21001: "USER_CHANNEL_MOVE", // 用户被移动到某个频道
  27001: "ROOM_LIST_UPDATE", // 房间列表全量更新
  31001: "SOUND_MESSAGE", //语音包消息
  32001: "SCREEN_SHARE_USER_UPDATE", // 房间内用户的屏幕共享状态变化
  32002: "GET_SCREEN_SHARE", // 获取屏幕共享
  'received_room_first_msg': 'RECEIVED_ROOM_FIRST_MSG', // 收到第一条房间通知
  'room_notify_type_change': 'ROOM_NOTIFY_TYPE_CHANGE', // 房间通知方式设置
  'channel_notify_setting_change': 'CHANNEL_NOTIFY_SETTING_CHANGE', // 频道通知方式设置
  'new_room_act': 'NEW_ROOM_ACT', // 新的房间活动推送
  'confirm_end_room_act': 'CONFIRM_END_ROOM_ACT', // 房间活动结束提醒
  'room_bot_permissions': 'ROOM_BOT_PERMISSIONS', // 房间机器人权限变更
  'matching_success': 'MATCHING_SUCCESS', // 匹配成功
  'matching_ready': 'MATCHING_READY', // 匹配准备
  'matching_enter_channel': 'MATCHING_ENTER_CHANNEL', // 匹配进入频道
  'create_channel': 'CREATE_CHANNEL', // 频道增删增量更新
  'timer_msg_failed': 'TIMER_MSG_FAILED', // 定时消息发送失败
  'anc_cron_room_finished': 'ANC_CRON_ROOM_FINISHED', // 房间定时任务更新
  'lottery_task_finish_info': 'LOTTERY_TASK_FINISH_INFO', // 抽奖任务完成信息
  'universal_popup': 'UNIVERSAL_POPUP', // 通用弹窗
  'oauth_need_more_scope': 'OAUTH_NEED_MORE_SCOPE', // BOT需要授权后使用
  'USER_IM_MESSAGE': 'USER_IM_MESSAGE', // 用户IM消息更新
  'CHAT_GROUP_MEMBER_CHANGE': "CHAT_GROUP_MEMBER_CHANGE", // 群聊成员变化
  'host_update': 'HOST_UPDATE', // 主持人更新
  'apply_host_update': 'APPLY_HOST_UPDATE', // 申请上麦更新
  'team_info_update': 'GLOBAL_TEAM_INFO_UPDATE', // 全局队伍信息更新
  'team_user_leave':'GLOBAL_TEAM_USER_LEAVE', // 全局队伍用户离开
  'team_voice': "TEAM_VOICE_INVITE", // 全局队伍发起语音邀请
  'MSG_NOTIFY': "MSG_NOTIFY", // 最近消息列表 内容更新消息通知
};

class WebSocketManager {
  constructor(deleteCacheCb) {
    this.websocketPath = "/chatroom/ws/connect";

    this.webSocket = null; // websocket实例
    this.isHeartReply = false; //连接状态 心跳用，等待心跳返回时会被置为false
    this.reConnectNum = 0; //重连次数
    this.reconnectTimeout; // 重连定时器
    this.reConnectTimestamp; // 重连时间戳
    this.socketConnecting = false; // socket连接标识符
    this.onopen_ws_id; // 当前链接成功的ws_id

    this.SEQUENCE_RECORD = {}; // 记录发送的请求，用于处理返回的请求
    this.waitResponseIds = {}; // 等待返回的ws请求 {id: {cb: callback, timer: timeout}}

    this.self = this; // 自身的指针
    this.ws_session = generateWsSession()

    this.deleteCacheCb = deleteCacheCb;
    // 心跳机制启动回调
    const startCallBack = () => {
      if (this.webSocket && this.webSocket.OPEN) {
        this.webSocketSend("PING");
        this.waitingServer();
      }
    };

    // 心跳机制等待回复
    const waitCallBack = () => {
      if (this.heartBeat.isHeartReply) {
        this.startHeartBeat();
        return;
      }
      clientLog("HeartBeat No Response");
      this.webSocketOnClose({
        heartBeat: true, // 心跳机制断线
      });
    };

    // 心跳机制实例
    this.heartBeat = new HeartBeat(startCallBack, waitCallBack);

    this.seq = 0; // 自增序列号
  }

  async initWebSocket(isReconnect) {
    if (this.webSocket !== null || this.socketConnecting) return;
    let ws_id = store.state.settings.ws_id;
    this.socketConnecting = true;
    if (isReconnect) {
      // 重连时判断时间戳，如果重连间隔（从断线到重连）超过一分钟，判断为息屏状态重连，按照掉线处理
      let now = new Date().getTime();
      if (
        this.reConnectTimestamp &&
        now - this.reConnectTimestamp > 1000 * 60
      ) {
        resetHeartbeat();
        EventBus.$emit("Connect_Error", "ws_disconnect");
        this.socketConnecting = false;
        return;
      }
      try {
        let res = await getWsId({}, true);
        if (res.data.status == "ok") {
          ws_id = res.data.result.ws_id;
        }
      } catch (e) {
        this.webSocketOnClose({
          heartBeat: true,
        });
        this.socketConnecting = false;
        return;
      }
    }
    if ("WebSocket" in window) {
      // 时间戳
      let t = ~~(+G.w() / 1000);

      // nonce生成
      let n = m(
        t + Math.random(new Date().getTime()).toString(),
      ).toLocaleUpperCase();
      let ws_url = getWsUrl(this.websocketPath, {
        ws_id,
        hkey: `${G.g(this.websocketPath, t + 1, n)}`,
        _time: t,
        nonce: n,
        ws_session: this.ws_session,
      })
      this.webSocket = new WebSocket(ws_url); //创建socket对象
      clientLog('initWebSocket', {
        ws_url,
        ws_session: this.ws_session,
        isReconnect,
      })
    } else {
      console.log("该浏览器不支持websocket!");
      this.socketConnecting = false;
      return;
    }
    //打开
    this.webSocket.onopen = () => {
      if (this.onopen_ws_id) {
        store.commit('SET_OLD_WS_ID', this.onopen_ws_id)
      } 
      this.onopen_ws_id = ws_id
      this.webSocketOpen(isReconnect);
    };
    //收信
    this.webSocket.onmessage = (e) => {
      this.webSocketOnMessage(e);
    };
    //关闭
    this.webSocket.onclose = (e) => {
      this.webSocketOnClose(e);
    };
    //连接发生错误的回调方法
    this.webSocket.onerror = (e) => {
      this.webSocketOnError(e);
    };
    this.socketConnecting = false;
  }

  //连接socket建立时触发
  webSocketOpen(isReconnect) {
    clientLog("websocket connect success");
    //首次握手
    this.heartBeat.changeHeartBeat(true);
    this.reConnectNum = 0;
    this.startHeartBeat();
    if (isReconnect) {
      EventBus.$emit("Socket_Connect");
      this.deleteCacheCb && this.deleteCacheCb();
    }
  }

  //客户端接收服务端数据时触发,e为接受的数据对象
  webSocketOnMessage(e) {
    // console.log("websocket信息:", e);
    this.heartBeat.changeHeartBeat(true);
    if (e.data.indexOf("PONG") === 0) {
      return;
    }
    const data = JSON.parse(e.data); //根据自己的需要对接收到的数据进行格式化
    console.log("WS: ", data ? JSON.parse(JSON.stringify(data)) : "null");

    let sequence = this.SEQUENCE_RECORD[data.type] || -1;
    let checkSequence = false;

    if (data.id !== undefined && this.waitResponseIds[data.id]) {
      this.waitResponseIds[data.id].cb(data);
    }

    // 如果是发送消息或者用户进出频道，则不判断是否为过期推送
    if ([2, 5].indexOf(data.type) >= 0) {
      checkSequence = true;
    } else {
      checkSequence = data.sequence > sequence;
    }

    if (TYPE_MAP[data.type] && checkSequence) {
      this.SEQUENCE_RECORD[data.type] = data.sequence;
      EventBus.$emit(`SOCKET_${TYPE_MAP[data.type]}`, data);
    }
  }

  //socket关闭时触发
  webSocketOnClose(e) {
    this.closeWebSocket(); // 手动关闭一下ws，防止同时启动多个ws
    clientLog("webSocket close", this.reConnectNum, e.reason);
    if (e.reason == "other user login") {
      this.resetHeartbeat();
      EventBus.$emit("Connect_Error", "relogin");
      // } else if (e.code == 1006 || e.heartBeat) {
      //被动断开 或 心跳检测，重新连接
    } else {
      clearTimeout(this.reconnectTimeout);
      let ws_reconnect_timeout =
        WS_RECOMMECT_TIMEOUT[
          Math.min(this.reConnectNum, WS_RECOMMECT_TIMEOUT.length - 1)
        ];
      // 如果是后端restart，不延迟直接重试，其他情况取范围随机数，防止同时重连导致堵塞(比如Nginx重启时)
      let timeout =
        e.code === 1012
          ? 0
          : getRandom(ws_reconnect_timeout - 2000, ws_reconnect_timeout + 2000);
      this.reconnectTimeout = setTimeout(() => {
        this.reConnectTimestamp = new Date().getTime();
        this.initWebSocket(true);
      }, timeout);
      this.reConnectNum += 1;
      if (this.reConnectNum > 3) {
        EventBus.$emit("Connect_Error", "ws_disconnect");
      }
    }
  }

  //连接发生错误的回调方法
  webSocketOnError(e) {
    this.heartBeat.stopHeartBeat();
    // heartBeat.isHeartReply = false; //断开后修改标识
    clientLog("webSocket error", e.reason);
    this.closeWebSocket();
  }

  //主动关闭socket
  closeWebSocket(e) {
    clientLog("closeWebSocket");
    this.webSocket && this.webSocket.close();
    this.webSocket = null;
    this.heartBeat.changeHeartBeat(false);
    this.resetHeartbeat();
  }

  //发送数据
  webSocketSend(data) {
    // console.log('发送socket: ', data)
    this.webSocket.send(typeof data == "string" ? data : JSON.stringify(data)); //在这里根据自己的需要转换数据格式
  }

  // 发送ws请求，根据id接收返回值
  wsRequest(path, p) {
    if (!path) return;
    p.ws_id = store.state.settings.ws_id;
    // 测试端添加测试前缀
    if (!process.env.IS_PROD) {
      let prefix = getCookie("ws_heybox_prefix") || "";
      path = prefix + path;
    }
    let params = {
      params: p,
      id: this.seq,
      method: path,
    };
    this.sendSock(params);
    this.seq += 1;
    if (this.seq >= Number.MAX_SAFE_INTEGER) {
      this.seq = 0;
    }

    return new Promise((resolve, reject) => {
      this.waitResponseIds[params.id] = {
        cb: (p) => {
          clearTimeout(this.waitResponseIds[params.id].timer);
          delete this.waitResponseIds[params.id];
          resolve({ data: p });
        },
        timer: setTimeout(() => {
          resolve({
            data: {
              status: "failed",
              msg: "请求超时",
            },
          });
        }, 10000),
      };
    }).then((res) => {
      if (res.data.status === 'redirect_room') {
        EventBus.$dynamic('RoomRedirectDialog', res.data.result)
      } else if (res.data.status === 'block_room') {
        const { is_owner, blocked_reason, blocked_until } = res.data.result
        let isOwner = !!Number(is_owner)
        const getTimeText = () => {
          const showTime = blocked_until === -1 ? '永久' : formatDateByTemplet(blocked_until)
          return blocked_until === -1 ? 
            '已被 <span class="text-tx-1">封禁</span>':
            `封禁至 <span class="text-tx-1">${showTime}</span>`
        }
        const toHome = () => {
          if(router.currentRoute.name === 'room' && router.currentRoute.params.room_id === p.room_id) {
            router.push({ name: 'home' })
          }
        }
        Vue.prototype.$query({
          config: {
            title: `${blocked_until === -1 ? '' : '暂时'}无法进入该房间`,
            desc: `该房间因 <span class="text-tx-1">${blocked_reason}</span> 处罚封禁，${getTimeText()}`,
            confirm: {
              text: isOwner ? '删除房间' : '退出房间',
              type: 'alert',
            },
            cancel: {
              text: '我知道了'
            }
          },
          confirmCB: () => {
            if (isOwner) {
              EventBus.$dynamic('RoomDelete', {
                room_id: p.room_id,
                cb: () => {}
              })
            } else {
              EventBus.$dynamic('RoomLeave', {
                room_id: p.room_id,
              })
              return 
            }
          },
          cancelCB: () => {
            toHome()
          }
        })
      } else if (
        res.data.status !== "ok" &&
        res.data.msg &&
        res.data.msg != "no_toast" &&
        !p._notip
      ) {
        Vue.prototype.$toast.error(res.data.msg);
      }
      return res;
    });
  }
  //发送数据
  sendSock(agentData) {
    const webSocket = this.webSocket;
    if (webSocket) {
      //下面的判断主要是考虑到socket连接可能中断或者其他的因素，可以重新发送此条消息。
      switch (webSocket.readyState) {
        //CONNECTING：值为0，表示正在连接。
        case webSocket.CONNECTING:
          setTimeout(() => {
            this.sendSock(agentData);
          }, 1000);
          break;
        //OPEN：值为1，表示连接成功，可以通信了。
        case webSocket.OPEN:
          this.webSocketSend(agentData);
          break;
        //CLOSING：值为2，表示连接正在关闭。
        case webSocket.CLOSING:
          setTimeout(() => {
            this.sendSock(agentData);
          }, 1000);
          break;
        //CLOSED：值为3，表示连接已经关闭，或者打开连接失败。
        case webSocket.CLOSED:
          // do something
          break;
        default:
          // this never happens
          break;
      }
    } else {
      // webSocket不存在等重连后延迟发送
      setTimeout(() => {
        this.sendSock(agentData);
      }, 1000);
    }
  }

  startHeartBeat() {
    this.heartBeat.startHeartBeat();
  }
  //延时等待服务端响应，通过webSocketState判断是否连线成功
  waitingServer() {
    this.heartBeat.waitingServer();
  }
  resetHeartbeat() {
    this.heartBeat.resetHeartBeat();
  }
}

function getWsUrl(path, params) {
  let url = `${WS_BASE}${path}`;
  return setUrlParam(url, {
    ...__DEFAULT_PARAMS__,
    ...params,
    heybox_id: store.getters.user_info.user_id
  })
}

function generateWsSession() {
  const timestamp = Date.now(); // 获取当前时间戳
  const randomNum = String(Math.floor(Math.random() * 100000)).padStart(5, '0'); // 生成五位随机数并填充前导零
  return `${timestamp}${randomNum}`;
}

export default WebSocketManager;